export const defaultStrings = {
  search: 'Search...',
  selectAll: 'Add All',
  removeAll: 'Remove All',
  selectedInfo: 'Items selected'
}
